export default __webpack_public_path__ + "static/media/paintball_xmas.95cbe959.png";